import {
    APP,
    CONTAINER_TARIFF,
} from 'Constant';
import {
    all,
    call,
    fork,
    put,
    putResolve,
    select,
    takeLatest,
} from 'redux-saga/effects';
import {
    getHashcode,
    validateHashcode,
} from '@vfde-fe/sails-validation';
import {
    API_CREDENTIALS,
    CREATE_INITIAL_STATE,
    GET_DEVICE_FAILED,
    GO_TO_BASKET,
    HANDLE_PAGESHOW,
    SAILS_PARAM_HARDWAREONLY,
    SAILS_READY_EVENT,
    SET_DEFAULT_STATE,
    TOGGLE_HARDWARE_ONLY,
    TOGGLE_INSURANCE,
    TOGGLE_TRADE_IN,
    TRIGGER_GIGAKOMBI_OVERLAY,
} from './constants';
import {
    getDeviceFailed,
    getDeviceSuccess,
    setDefaultState,
    showLoading,
    toggleInsurance,
} from './actions';
import {
    selectGigakombi,
    selectSalesChannel,
    selectSubscription,
    selectSubscriptionId,
} from '../Tariff/selectors';
import {
    getSessionStorage,
    getSessionStorageItemJson,
    request,
    setSessionStorage,
    SHOP_URL,
    triggerOverlay,
} from '@vfde-fe/sails_core';
import {
    getGigakombi,
    getGigakombiEligibilityToken,
    getRestlaufzeit,
    getSaleschannel,
    getSubscriptionId,
} from '../Tariff/helper/getSubscriptionDataHelper';
import mountOptionsContainer from '../Options';
import {
    ADDITIONAL_PAGE_OPTIONS,
    API_BTX_BNT,
    BTX_BNT,
    BTX_REDPLUS,
    FAMILY_FRIENDS_ID,
    GIGAKOMBI_DUMMY_SOCS,
    GIGAKOMBI_MARKER_SOC,
    INSURANCE_ID,
    MAP_SALESCHANNEL_TO_API_SALESCHANNEL,
    MAP_SALESCHANNEL_TO_GROUP_ID,
    RED_L_GROUP,
    RED_XL_GROUP,
    RLZ_SOC,
    SAILS_BNT_STORAGE,
    SAILS_PARAM_GIGAKOMBI,
    SAILS_PARAM_INSURANCE,
    SAILS_PARAM_SALESCHANNEL,
    SAILS_PARAM_SUB_ID,
    SALESCHANNEL_CONSUMER,
    SALESCHANNEL_FAMILY_FRIENDS,
    SALESCHANNEL_REDPLUS,
    SALESCHANNEL_SOHO,
    SOHO_ID,
    SOHO_GIGAMOBIL_XL_SOC,
    TRADE_IN_SOC,
    YOUNG_L_PLUS_GROUP,
    YOUNG_XL_GROUP,
    SAILS_PARAM_TRADE_IN,
    SAILS_PARAM_TAUSCHBONUS,
    SOHO_XL_ID,
} from '@vfde-fe/sails-constants';
import { setDefaultState as setTariffDefaultState } from '../Tariff/actions';
import { GIGAKOMBI_OVERLAY_NAME } from '../Overlay/constant';
import {
    selectHardwareOnly,
    selectInsurance,
    selectInsuranceSelected,
} from './selectors';
import merge from 'lodash.merge';
import {
    getHardwareOnly,
    getInsurance,
    getTauschbonus,
    getTradeIn,
} from './helpers/getCustomerConfig';
import { trackInsurance } from 'Helper/tracking';
import { trackPageView } from '../Options/helpers/tracking';
import { createSailsReadyEvent } from './helpers/publicFunctions';
import { selectAtomicId } from '../Options/selectors';
import {
    BASKET_PROPOSITION_BNT,
    BASKET_PROPOSITION_HARDWAREONLY,
    BASKET_PROPOSITION_REDPLUS,
    createBasket,
    createBasketItem,
    createBasketProposition,
    generateDeeplink,
    getApiCredentials,
} from '@vfde-fe/utils';
import {
    getInsuranceFromSails,
    SailsBntStorage,
    updateStorageSaga,
} from '@vfde-fe/sails-storage';
import { getIsRestlaufzeitEligible } from './helpers/getIsRestlaufzeitEligible';
import { selectTradeIn, selectTauschbonus } from '../TradeIn/selectors';
import { getIsTauschbonusEligible } from './helpers/getIsTauschbonusEligible';
import {getTauschbonusSoc} from './helpers/getTauschbonusSoc';
import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';

/**
 * hardwareDetail saga
 * Watches actions
 */
export default function* hardwareDetailSaga () {
    yield takeLatest(CREATE_INITIAL_STATE, createInitialStateSaga);
    yield takeLatest(TRIGGER_GIGAKOMBI_OVERLAY, triggerGigaKombiOverlay);
    yield takeLatest(TOGGLE_HARDWARE_ONLY, toggleHardwareOnlySaga);
    yield takeLatest(TOGGLE_INSURANCE, setInsuranceSaga);
    yield takeLatest(SET_DEFAULT_STATE, toggleHardwareOnlySaga);
    yield takeLatest(TOGGLE_TRADE_IN, toggleTradeInSaga);
    yield takeLatest(GO_TO_BASKET, goToBasketSaga);
    yield takeLatest(GET_DEVICE_FAILED, getDeviceFailedSaga);
    yield takeLatest(HANDLE_PAGESHOW, handlePageShowSaga);
}

/**
 * createInitialState
 */
export function* createInitialStateSaga (action) {
    yield put(showLoading());
    const {deviceId} = window.additionalPageOptions;
    const salesChannel = yield getSaleschannel();
    const subscriptionId = yield getSubscriptionId(salesChannel);
    if (salesChannel === SALESCHANNEL_FAMILY_FRIENDS) {
        const hashcode = yield getHashcode();
        yield putResolve(validateHashcode(hashcode));
    }
    const gigakombi = yield getGigakombi(salesChannel);
    const insurance = yield getInsurance();
    const isHardwareOnly = yield getHardwareOnly();
    const isTradeIn = yield getTradeIn();
    const isTauschbonus = yield getTauschbonus(isTradeIn);
    const gigakombiToken = yield call(getGigakombiEligibilityToken);
    yield put(setTariffDefaultState(salesChannel, MAP_SALESCHANNEL_TO_GROUP_ID[salesChannel].indexOf(Number(subscriptionId)) !== -1 ? subscriptionId : null, gigakombi, gigakombiToken));
    yield put(setDefaultState(isHardwareOnly, insurance, isTradeIn, isTauschbonus));
    yield getDeviceSaga({deviceId});
    yield call(updateStorageSaga, SAILS_BNT_STORAGE, {
        [SAILS_PARAM_TAUSCHBONUS]: isTauschbonus,
    });
    yield call(createSailsReadyEvent, SAILS_READY_EVENT, action.actions);
}

const getDevicesPayload = ({deviceId, salesChannel, subscriptionId, gigakombi, isTradeInEligible, isTauschbonusEligible}) => {
    const payload: any = {
        productIds: [
            deviceId.toString(),
        ],
        offerBtx: API_BTX_BNT,
        offerSalesChannel: MAP_SALESCHANNEL_TO_API_SALESCHANNEL[salesChannel],
        subscriptionIds: MAP_SALESCHANNEL_TO_GROUP_ID[salesChannel].filter(value => {
            if (SALESCHANNEL_FAMILY_FRIENDS === salesChannel) {
                // Remove Red XL and Young L+ from subscription IDs for F&F
                return value !== RED_XL_GROUP && value !== YOUNG_L_PLUS_GROUP;
            }

            // Remove Red L and Young L+ from the subscription IDs sent to the API for the device first use case
            return value !== RED_L_GROUP && value !== YOUNG_L_PLUS_GROUP;
        }).map(value => value.toString()),
        discounts: [],
    };

    gigakombi && payload.discounts.push(GIGAKOMBI_MARKER_SOC, GIGAKOMBI_DUMMY_SOCS[subscriptionId]);

    if (salesChannel === SALESCHANNEL_FAMILY_FRIENDS) {
        // Replace discounts array from Gigakombi because Gigakombi and F&F are not combinable
        payload.discounts = [
            FAMILY_FRIENDS_ID,
        ];
    }

    // Add other discounts: Soho and Tradein
    salesChannel === SALESCHANNEL_SOHO && payload.discounts.push(SOHO_ID, SOHO_XL_ID);
    isTradeInEligible && payload.discounts.push(TRADE_IN_SOC);
    isTauschbonusEligible && payload.discounts.push(getTauschbonusSoc(deviceId));

    if (subscriptionId) {
        payload.subscriptionIds = [
            subscriptionId.toString(),
        ];
    }

    return payload;
};

/** * getDevice saga
 * Fetches the API data
 */
export function* getDeviceSaga (action) {
    const [salesChannel, subscriptionId, gigakombi] = yield all([
        select(selectSalesChannel()),
        select(selectSubscriptionId()),
        select(selectGigakombi()),
    ]);

    const { deviceId } = action;

    const isTauschbonusEligible = yield call(getIsTauschbonusEligible);
    const isTradeInEligible = isTauschbonusEligible;

    const {key, url} = getApiCredentials(API_CREDENTIALS);
    const payload = getDevicesPayload({deviceId, salesChannel, subscriptionId, gigakombi, isTradeInEligible, isTauschbonusEligible});
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': key,
        },
        body: JSON.stringify(payload),
    };

    try {
        const response = yield call(request, url, options);

        const { status, body } = response;

        if (status === 200) {
            yield put(getDeviceSuccess(body));
            yield call(mountOptionsContainer);
        }
    } catch (err) {
        const { status, body } = err;

        if (status === 400) {
            yield put(getDeviceFailed(body));
        }
    }
}

/**
 * Get device failed saga
 */
export function* getDeviceFailedSaga (action) {
    const errorCode = action.error.code;
    let errorPageUrl: string;

    switch (errorCode) {
        case '400.05':
            errorPageUrl = window[ADDITIONAL_PAGE_OPTIONS].apiError?.[errorCode];
            break;
    }

    yield call([window.location, 'assign'], errorPageUrl);
}

/**
 * Gigakombi overlay
 */
export function* triggerGigaKombiOverlay () {
    const url = yield generateDeeplinkSaga();
    yield call(setSessionStorage, 'deeplink', url.replace(SHOP_URL, ''));
    const {beforeOpenGigaKombiOverlayLegacy} = window as any;
    beforeOpenGigaKombiOverlayLegacy && beforeOpenGigaKombiOverlayLegacy();
    yield put(triggerOverlay(undefined, GIGAKOMBI_OVERLAY_NAME));
}

/**
 * Toggle Hardware
 */
export function* toggleHardwareOnlySaga () {
    const [isHardwareOnly, deviceId, storage, insuranceSelected] = yield all([
        select(selectHardwareOnly()),
        window[ADDITIONAL_PAGE_OPTIONS].deviceId,
        call(getSessionStorage, SAILS_BNT_STORAGE),
        select(selectInsuranceSelected()),
    ]);

    // Store hardware only state per hubpage
    const newStorage = merge({}, storage, {
        [APP]: {
            [deviceId]: {
                [SAILS_PARAM_HARDWAREONLY]: isHardwareOnly,
            },
        },
        [SAILS_PARAM_INSURANCE]: insuranceSelected,
    });

    if (isHardwareOnly) {
        // Remove subscription related stuff from session storage and save it for later, because old NSF does NOT like it when hardware only is true...
        // We check for subscription data in old backup storage first, then in main storage.
        const tariffStorage = storage[APP]?.[CONTAINER_TARIFF] ? storage[APP][CONTAINER_TARIFF] : storage;
        const {
            [SAILS_PARAM_SUB_ID]: activeSubscriptionId,
            [SAILS_PARAM_GIGAKOMBI]: gigakombi,
            [SAILS_PARAM_INSURANCE]: insurance,
            [SAILS_PARAM_TRADE_IN]: tradeIn,
            [SAILS_PARAM_SALESCHANNEL]: salesChannel,
        } = tariffStorage;

        if (activeSubscriptionId || gigakombi || insurance || tradeIn || salesChannel) {
            // Create tariff storage inside SAILS_BNT_STORAGE, so we keep track on the previous flags before hardware only was switched on
            newStorage[APP][CONTAINER_TARIFF] = (({ activeSubscriptionId, gigakombi, insurance, tradeIn, salesChannel }) => ({activeSubscriptionId, gigakombi, insurance, tradeIn, salesChannel}))(tariffStorage);
        }
        // We have to set the saleschannel to consumer when toggling hardwareOnly, as the basket only accepts this channel for hardwareOnly
        newStorage[SAILS_PARAM_SALESCHANNEL] = SALESCHANNEL_CONSUMER;
        delete newStorage[SAILS_PARAM_SUB_ID];
        delete newStorage[SAILS_PARAM_GIGAKOMBI];
        delete newStorage[SAILS_PARAM_INSURANCE];
        delete newStorage[SAILS_PARAM_TRADE_IN];
    } else {
        // If there is a subscription backup, put it back where it belongs
        if (storage[APP]?.[CONTAINER_TARIFF]) {
            merge(newStorage, storage[APP][CONTAINER_TARIFF]);
            delete newStorage[APP][CONTAINER_TARIFF];
        }
    }

    yield call(setSessionStorage, SAILS_BNT_STORAGE, newStorage);
    yield trackPageView();
}

/**
 * Toggle trade in
 * @param action
 */
export function* toggleTradeInSaga (action) {
    const isTradeIn = yield select(selectTradeIn());
}

/**
 * Set insurance status in session storage
 */
export function* setInsuranceSaga (action) {
    const { trackIt } = action;
    const [insurance, insuranceSelected] = yield all([
        select(selectInsurance()),
        select(selectInsuranceSelected()),
    ]);
    yield call(updateStorageSaga, SAILS_BNT_STORAGE, {
        [SAILS_PARAM_INSURANCE]: insuranceSelected,
    });

    if (trackIt) {
        yield fork(trackInsurance, {insurance, insuranceSelected});
    }
}

/**
 * Go to basket
 */
export function* goToBasketSaga () {
    const url = yield generateDeeplinkSaga();

    yield call([window.location, 'assign'], url);
}

/**
 * Generate deeplink
 */
export function* generateDeeplinkSaga () {
    const serviceIds = [];
    const discountIds = [];

    const [
        salesChannel,
        atomicId,
        hasInsurance,
        isGigakombi,
        tariffId,
        offer,
        isHardwareOnly,
        isRestlaufzeit,
        isTradeIn,
        isTauschbonus,
    ] = yield all([
        select(selectSalesChannel()),
        select(selectAtomicId()),
        select(selectInsuranceSelected()),
        select(selectGigakombi()),
        select(selectSubscriptionId()),
        select(selectSubscription()),
        select(selectHardwareOnly()),
        getRestlaufzeit(),
        select(selectTradeIn()),
        select(selectTauschbonus())
,    ]);

    const btx = salesChannel === SALESCHANNEL_REDPLUS ? BTX_REDPLUS : BTX_BNT;

    if (!isHardwareOnly) {
        (hasInsurance && atomicId) && serviceIds.push(INSURANCE_ID);
        if (isGigakombi) {
            serviceIds.push(GIGAKOMBI_MARKER_SOC);
            // Gigakombi dummy socs are not available for unlimited XL tariffs
            if ([RED_XL_GROUP, YOUNG_XL_GROUP].indexOf(Number(tariffId)) === -1) {
                serviceIds.push(GIGAKOMBI_DUMMY_SOCS[tariffId]);
            }
        }

        // add trade in soc if trade-in is true
        if (isTradeIn) {
            discountIds.push(TRADE_IN_SOC);

            if (isTauschbonus) {
                const deviceId = window[ADDITIONAL_PAGE_OPTIONS].deviceId;
                discountIds.push(getTauschbonusSoc(deviceId));
            }
        }

        const isRestlaufzeitEligible = getIsRestlaufzeitEligible(isGigakombi, salesChannel, Number(tariffId));
        isRestlaufzeitEligible && isRestlaufzeit && serviceIds.push(RLZ_SOC);
        salesChannel === SALESCHANNEL_SOHO && tariffId === RED_XL_GROUP && discountIds.push(SOHO_GIGAMOBIL_XL_SOC);

    }

    const basketItem = createBasketItem(!isHardwareOnly ? offer.id : undefined, atomicId, discountIds, serviceIds);

    const propositionType = isHardwareOnly ? BASKET_PROPOSITION_HARDWAREONLY : salesChannel === SALESCHANNEL_REDPLUS ? BASKET_PROPOSITION_REDPLUS : BASKET_PROPOSITION_BNT;
    const proposition = createBasketProposition(propositionType, [basketItem]);

    const basket = createBasket(salesChannel, [proposition]);

    return generateDeeplink(basket, true);
}

/**
 * Handle pageshow saga
 * On cached pageshow (e.g. afer forwards or backwards navigation)
 * trigger a `toggleInsurance` action to make sure, the feature-card and price
 * is up-to-date based on the session-storage property.
 * This is relevant, if the user selects or deselects insurance on the
 * Connect-More-Page and uses the browser-back-button which brings him back to DDP again.
 */
export function* handlePageShowSaga (action: AnyAction): SagaIterator {
    const event = action.event as PageTransitionEvent;

    if (!event.persisted) {
        // we only care for cached page navigations
        return;
    }

    const sailsBnt: SailsBntStorage = yield call(getSessionStorageItemJson, SAILS_BNT_STORAGE);

    if (!sailsBnt) {
        return;
    }

    const hasInsurance = yield call(getInsuranceFromSails, sailsBnt);

    yield put(toggleInsurance(hasInsurance, true, false));
}
